import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export var normalizeAssignmentPermission = function normalizeAssignmentPermission(value) {
  var _value$classIds, _value$userIds;

  return {
    mode: (value === null || value === void 0 ? void 0 : value.mode) === 'restricted' ? 'restricted' : 'global',
    classIds: (value === null || value === void 0 ? void 0 : value.mode) === 'restricted' ? _toConsumableArray(new Set(((_value$classIds = value.classIds) !== null && _value$classIds !== void 0 ? _value$classIds : []).map(function (id) {
      return id.trim();
    }).filter(Boolean))) : [],
    userIds: (value === null || value === void 0 ? void 0 : value.mode) === 'restricted' ? _toConsumableArray(new Set(((_value$userIds = value.userIds) !== null && _value$userIds !== void 0 ? _value$userIds : []).map(function (id) {
      return id.trim();
    }).filter(Boolean))) : []
  };
};
export var isValidAssignmentPermission = function isValidAssignmentPermission(value) {
  var permission = normalizeAssignmentPermission(value);
  return permission.mode === 'global' || permission.classIds.length <= 100 && permission.userIds.length <= 1000 && permission.classIds.length + permission.userIds.length > 0 && [].concat(_toConsumableArray(permission.classIds), _toConsumableArray(permission.userIds)).every(function (id) {
    return id.length <= 256;
  });
};